import { Imatge, getCrop, getImatge, getPeu } from '@portal-internet/components';
export { Imatge as default, getCrop, getImatge, getPeu };
